import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, filter, from, map, tap } from 'rxjs';

import { AsyncPipe, NgIf, NgStyle } from '@angular/common';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyTableModule } from '@angular/material/legacy-table';
import * as _ from 'lodash';
import { ImageViewerComponent } from '../../components/image-viewer/image-viewer.component';
import { CuttingButt } from '../../models/cutting/cutting-butt.model';
import { CuttingButtFormService } from '../../services/cutting-butt-form.service';
import { LegacyDialogsService } from '../../services/legacy-dialogs.service';
import {
  MaterialBaseButtsDialogComponent,
  MaterialBaseEdgeDialogData,
} from '../material-base-butts-dialog/material-base-butts-dialog.component';

@Component({
  selector: 'csl-edges-in-color',
  templateUrl: './edges-in-color.component.html',
  styleUrls: ['./edges-in-color.component.scss'],
  standalone: true,
  imports: [MatLegacyTableModule, MatLegacyCheckboxModule, MatLegacyButtonModule, NgStyle, NgIf, AsyncPipe],
})
export class EdgesInColorComponent implements OnInit {
  @Input() materialInMatBaseId: number;
  @Input() panelThickness?: number;
  @Input() showQuantityInStock?: boolean;

  data$: Observable<CuttingButt[]>;
  action$: Observable<any>;

  displayedColumns = ['select', 'texture', 'article', 'name', 'thickness'];

  selection: SelectionModel<CuttingButt> = new SelectionModel(false);

  @Output() selectionChange = this.selection.changed.pipe(map(c => c.source.selected));
  @Output() selectedFromMatBase = new EventEmitter<CuttingButt>();

  constructor(
    private cuttingButtFormService: CuttingButtFormService,

    private dialogs: LegacyDialogsService
  ) {}

  ngOnInit(): void {
    this.data$ = from(
      this.cuttingButtFormService.getMatchedButtsForClient(this.materialInMatBaseId, this.panelThickness)
    );

    if (!this.showQuantityInStock) {
      _.pull(this.displayedColumns, 'quantityInStock');
    }
  }

  openTextureViewerDialog(link: string): void {
    this.action$ = this.dialogs.component(ImageViewerComponent, { textureLink: link }, 0, {
      panelClass: 'image-viewer-dialog',
    });
  }

  chooseButtFormMatBase(): void {
    this.action$ = this.getButtFromMatBase().pipe(
      filter(butt => !_.isUndefined(butt)),
      tap(butt => this.selectedFromMatBase.emit(butt))
    );
  }

  private getButtFromMatBase(): Observable<CuttingButt> {
    return this.dialogs.component<MaterialBaseEdgeDialogData, CuttingButt>(
      MaterialBaseButtsDialogComponent,
      {
        panelThickness: this.panelThickness ? this.panelThickness : 0,
      },
      1000
    );
  }
}
